/**
 * EmptyState — contextual empty state for the residents table.
 * @param {{ type: 'no-data' | 'no-results', onAddResident?: () => void, onClearFilters?: () => void }} props
 */
const EmptyState = ({ type, onAddResident, onClearFilters }) => {
  if (type === 'no-data') {
    return (
      <div className="rp-empty">
        <div className="rp-empty__icon-wrap">
          <svg className="rp-icon-xl rp-empty__icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
          </svg>
        </div>
        <h3 className="rp-empty__title">No residents yet</h3>
        <p className="rp-empty__text">
          Get started by adding your first resident to this campus. Residents will appear here once added.
        </p>
        {onAddResident && (
          <button
            type="button"
            onClick={onAddResident}
            className="rp-btn rp-btn--primary"
          >
            <svg className="rp-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Add Resident
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="rp-empty">
      <div className="rp-empty__icon-wrap">
        <svg className="rp-icon-xl rp-empty__icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
      </div>
      <h3 className="rp-empty__title">No results found</h3>
      <p className="rp-empty__text">
        No residents match your current search or filter criteria. Try adjusting your search terms or clearing filters.
      </p>
      {onClearFilters && (
        <button
          type="button"
          onClick={onClearFilters}
          className="rp-btn rp-btn--outline"
        >
          <svg className="rp-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Clear All Filters
        </button>
      )}
    </div>
  );
};

export default EmptyState;
